module.exports = __webpack_public_path__ + "images/feature/0717_cal_rp_2-d21facf0a3cd2a85cd0bbc4e29885032.jpg";